"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("antd/lib/page-header/style/css");
var page_header_1 = __importDefault(require("antd/lib/page-header"));
require("antd/lib/card/style/css");
var card_1 = __importDefault(require("antd/lib/card"));
require("antd/lib/descriptions/style/css");
var descriptions_1 = __importDefault(require("antd/lib/descriptions"));
require("antd/lib/typography/style/css");
var typography_1 = __importDefault(require("antd/lib/typography"));
require("antd/lib/button/style/css");
var button_1 = __importDefault(require("antd/lib/button"));
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var icons_1 = require("@ant-design/icons");
var utils_1 = require("../../utils");
var HTMLContent_1 = __importDefault(require("../HTMLContent"));
var jsx_runtime_1 = require("@welldone-software/why-did-you-render/jsx-runtime");
var styles = {
    revision: {
        marginTop: 16
    },
    modalCard: {
        marginTop: 16
    }
};
var modalDetailTitle = (0, utils_1.detailTitle)("Modal", "title");
var ModalDetailView = /*#__PURE__*/ react_1.default.memo(function () {
    var _modal$revision$numbe, _modal$revision, _modal$revision$messa, _modal$revision2, _modal$revision$times, _modal$revision3;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _useParams = (0, react_router_dom_1.useParams)(), modalID = _useParams.id;
    var modalsInitialFetch = (0, react_redux_1.useSelector)(function (state) {
        return state.modals.initialFetchDone;
    });
    var modalsFetching = (0, react_redux_1.useSelector)(function (state) {
        return state.modals.isFetching;
    });
    var modal = (0, react_redux_1.useSelector)(function (state) {
        return (0, utils_1.findItemByID)(state.modals.items, modalID);
    });
    var onBack = (0, react_1.useCallback)(function () {
        return navigate(-1);
    }, [navigate]);
    var editModal = (0, react_1.useCallback)(function () {
        return navigate("/modals/edit/".concat(modalID));
    }, [navigate, modalID]);
    var title = (0, react_1.useMemo)(function () {
        return modalDetailTitle(modal, modalsInitialFetch, modalsFetching);
    }, [modalsInitialFetch, modalsFetching, modal]);
    var extra = (0, react_1.useMemo)(function () {
        return [(0, jsx_runtime_1.jsx)(button_1.default, {
                icon: (0, jsx_runtime_1.jsx)(icons_1.EditOutlined, {}),
                onClick: editModal,
                children: "Edit"
            }, "edit")];
    }, [editModal]);
    return (0, jsx_runtime_1.jsxs)(page_header_1.default, {
        ghost: false,
        onBack: onBack,
        title: title,
        extra: extra,
        children: [(0, jsx_runtime_1.jsx)(typography_1.default.Title, {
                level: 2,
                children: modal.title
            }), (0, jsx_runtime_1.jsx)(descriptions_1.default, {
                bordered: true,
                size: "small",
                children: (0, jsx_runtime_1.jsx)(descriptions_1.default.Item, {
                    label: "Close Text",
                    children: modal.close_text
                })
            }), (0, jsx_runtime_1.jsxs)(descriptions_1.default, {
                bordered: true,
                size: "small",
                style: styles.revision,
                children: [(0, jsx_runtime_1.jsx)(descriptions_1.default.Item, {
                        label: "Revision",
                        span: 1,
                        children: (_modal$revision$numbe = modal === null || modal === void 0 || (_modal$revision = modal.revision) === null || _modal$revision === void 0 ? void 0 : _modal$revision.number) !== null && _modal$revision$numbe !== void 0 ? _modal$revision$numbe : ""
                    }), (0, jsx_runtime_1.jsx)(descriptions_1.default.Item, {
                        label: "Update",
                        span: 1,
                        children: (_modal$revision$messa = modal === null || modal === void 0 || (_modal$revision2 = modal.revision) === null || _modal$revision2 === void 0 ? void 0 : _modal$revision2.message) !== null && _modal$revision$messa !== void 0 ? _modal$revision$messa : ""
                    }), (0, jsx_runtime_1.jsx)(descriptions_1.default.Item, {
                        label: "Last Updated",
                        span: 1,
                        children: (_modal$revision$times = modal === null || modal === void 0 || (_modal$revision3 = modal.revision) === null || _modal$revision3 === void 0 ? void 0 : _modal$revision3.timestamp) !== null && _modal$revision$times !== void 0 ? _modal$revision$times : ""
                    })]
            }), (0, jsx_runtime_1.jsxs)(card_1.default, {
                size: "small",
                title: "Content",
                style: styles.modalCard,
                children: [(0, jsx_runtime_1.jsx)(HTMLContent_1.default, {
                        id: "modal-detail-content",
                        htmlContent: modal === null || modal === void 0 ? void 0 : modal.content
                    }), (0, jsx_runtime_1.jsx)(button_1.default, {
                        children: modal === null || modal === void 0 ? void 0 : modal.close_text
                    })]
            })]
    });
});
exports.default = ModalDetailView;
